<sh-form-date
    *ngIf="profileField$ | async as profileField"
    [id]="profileField.FieldDefinition.FlatKey"
    [label]="profileField.DisplayLabel"
    [labelIcons]="labelIcons"
    [helpText]="profileField.Description"
    [control]="control$ | async"
    [errorMsg]="(errorMsg$ | async) || '' | translate"
    [placeholder]="'form.date.format' | translate"
    [invalidFormatMsg]="'form.date.invalid-format' | translate: { date: dateExample }"
    [invalidDateMsg]="'form.date.invalid-date' | translate"
    [canBeIndeterminate]="canBeIndeterminate"
    [indeterminateMsg]="'general.different-values' | translate"
    [title]="disabledMessageKey | translate"
>
    <ng-content></ng-content
></sh-form-date>
